define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi/state/rootStore"
], function(declare, Widget, {routerStore}) {

	var SOURCE_REVIEW = "SourceReview";

	return declare(Widget, {
		_resolveView: function() {
			const {locationType, locationUrl} = routerStore;

			if (locationType && ["OperationsReview", "FactoryReview", "SupplierReview"].includes(locationType)) {
				this.addFixedValue(SOURCE_REVIEW, locationUrl);
			}

			this.inherited(arguments);
		}
	});
});
